import { Box, Modal, CircularProgress, Alert } from "@mui/material";
import { useMyContext } from "../../context";
import { modalStyle } from "../../MUIStyles";
import useRoles from "../../hooks/useRoles";

const RoleDetails = () => {
  const { modalStates, handleCloseModal, setId, id } = useMyContext();
  console.log(id);

  const {
    roleDetails,
    roleDetailsLoading,
    roleDetailsError,
    roleDetailsIsError,
  } = useRoles();

  // دالة واحدة للإغلاق تمسح الـ id وتغلق المودال
  const handleClose = () => {
    setId(""); // مسح الـ id أولاً
    handleCloseModal("roleDetails"); // ثم إغلاق المودال
  };

  // Loading state
  if (roleDetailsLoading) {
    return (
      <Modal open={modalStates.roleDetails} onClose={handleClose}>
        <Box
          sx={{
            ...modalStyle,
            maxHeight: "90vh",
            width: { lg: "600px", xs: "400px" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="flex flex-col items-center gap-4">
            <CircularProgress />
            <p className="text-gray-600">Loading role details...</p>
          </div>
        </Box>
      </Modal>
    );
  }

  // Error state
  if (roleDetailsIsError) {
    return (
      <Modal open={modalStates.roleDetails} onClose={handleClose}>
        <Box
          sx={{
            ...modalStyle,
            maxHeight: "90vh",
            width: { lg: "600px", xs: "400px" },
          }}
        >
          <div className="flex flex-col gap-6 items-center p-6">
            <Alert severity="error" className="w-full">
              Failed to load role details:{" "}
              {roleDetailsError?.message || "Unknown error occurred"}
            </Alert>
            <button
              onClick={handleClose}
              className="w-[160px] h-[50px] rounded-[50px] bg-black text-white cursor-pointer"
            >
              Close
            </button>
          </div>
        </Box>
      </Modal>
    );
  }

  // Get the role data
  const roleData = roleDetails?.data;

  // Handle empty data
  if (!roleData) {
    return (
      <Modal open={modalStates.roleDetails} onClose={handleClose}>
        <Box
          sx={{
            ...modalStyle,
            maxHeight: "90vh",
            width: { lg: "600px", xs: "400px" },
          }}
        >
          <div className="flex flex-col gap-6 items-center p-6">
            <Alert severity="info" className="w-full">
              No role data available
            </Alert>
            <button
              onClick={handleClose}
              className="w-[160px] h-[50px] rounded-[50px] bg-black text-white cursor-pointer"
            >
              Close
            </button>
          </div>
        </Box>
      </Modal>
    );
  }

  return (
    <Modal open={modalStates.roleDetails} onClose={handleClose}>
      <Box
        sx={{
          ...modalStyle,
          maxHeight: "90vh",
          overflowY: "auto",
          width: { lg: "600px", xs: "400px" },
        }}
      >
        <div className="flex flex-col gap-8 items-center font-semibold">
          <h3 className="text-xl">Role Details</h3>
          <div className="w-full flex flex-col gap-4 items-start">
            {/* Role ID */}
            <p className="flex items-center gap-2 font-medium">
              <span className="font-semibold">Role ID:</span> #{roleData.id}
            </p>

            {/* Role Name */}
            <p className="flex items-center gap-2 font-medium">
              <span className="font-semibold">Role Name:</span>
              {roleData.name?.charAt(0).toUpperCase() +
                roleData.name?.slice(1) || "-"}
            </p>

            {/* Role Description */}
            <div className="flex flex-col gap-3">
              <h4 className="font-semibold">Role Description:</h4>
              <p className="font-medium">
                {roleData.note || "No description available"}
              </p>
            </div>

            {/* Created Date */}
            <p className="font-medium flex items-center gap-2">
              <span className="font-semibold">Created on:</span>
              {roleData.created_at ? roleData.created_at.split(" ")[0] : "-"}
            </p>

            {/* Last Updated */}
            <p className="font-medium flex items-center gap-2">
              <span className="font-semibold">Last updated:</span>
              {roleData.updated_at}
            </p>

            {/* Number of Employees */}
            <div className="flex flex-col gap-5 w-full">
              <h4 className="font-semibold">
                Number of Employees Holding This Role:{" "}
                {roleData.users_count || 0}
              </h4>

              {/* Users List */}
              {roleData.users && roleData.users.length > 0 ? (
                <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3">
                  {roleData.users.map((user, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-2 font-medium"
                    >
                      <img
                        src={user.profile_picture || "/img/person.png"}
                        alt={user.name || "User"}
                        className="w-12 h-12 rounded-full object-cover"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/img/person.png";
                        }}
                      />
                      {user.name || `User ${index + 1}`}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="font-medium text-gray-500">
                  No employees assigned to this role
                </p>
              )}
            </div>

            {/* Permissions */}
            <div className="w-full">
              <h4 className="mb-4">Permissions:</h4>

              {roleData.permissions && roleData.permissions.length > 0 ? (
                <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-2 w-full">
                  {roleData.permissions.map((permission) => (
                    <div
                      key={permission.id}
                      className="flex items-center gap-3"
                    >
                      <div className="relative">
                        <input
                          type="checkbox"
                          id={`permission-${permission.id}`}
                          checked={true}
                          readOnly
                          className="
                            w-5 h-5 
                            appearance-none 
                            border-2 border-gray-400 
                            rounded 
                            checked:bg-secondary 
                            checked:border-secondary
                            cursor-default
                          "
                        />
                        <img
                          src="/img/checked.svg"
                          alt="Checked"
                          className="
                            absolute top-1 left-0.5 
                            w-4 h-3
                            pointer-events-none
                          "
                        />
                      </div>
                      <label
                        htmlFor={`permission-${permission.id}`}
                        className="font-medium cursor-default text-sm"
                      >
                        {permission.name}
                      </label>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="font-medium text-gray-500">
                  No permissions assigned to this role
                </p>
              )}

              {/* Permissions Count */}
              {roleData.permissions && roleData.permissions.length > 0 && (
                <div className="mt-4 p-2 bg-gray-50 rounded">
                  <p className="text-sm font-medium">
                    Total permissions: {roleData.permissions.length}
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Close Button */}
          <button
            onClick={handleClose}
            className="w-[160px] h-[50px] rounded-[50px] bg-black text-white cursor-pointer hover:bg-gray-800 transition"
          >
            Close
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default RoleDetails;
